<script lang="ts" setup>
import { toTypedSchema } from '@vee-validate/zod';
import { useField } from 'vee-validate';
import { inject, ref } from 'vue';
import { z } from 'zod';
import VInput from '@shared/form/VInput/VInput.vue';
import FieldRowV2 from '@shared/form/FieldRowV2/FieldRowV2.vue';
import {
  hideRequiredAsteriskInjectionKey,
  isDisabledInjectionKey,
  isReadonlyInjectionKey,
} from '../keys';

const { value: hasDisabledParent } = inject(isDisabledInjectionKey, { value: ref(false) });
const { value: hasReadonlyParent } = inject(isReadonlyInjectionKey, { value: ref(false) });
const { value: hideRequiredAsteriskParent } = inject(hideRequiredAsteriskInjectionKey, {
  value: ref(false),
});
const maxLength = 32;
const { errors, value } = useField('bedrijfsnaam', toTypedSchema(z.string().min(1).max(maxLength)));
const fieldId = 'relatiegegevens-bedrijfsnaam';
</script>

<template>
  <FieldRowV2
    :errors
    label="Bedrijfsnaam"
    :label-for="fieldId"
    :required="!hideRequiredAsteriskParent && !hasReadonlyParent"
  >
    <VInput
      v-if="!hasReadonlyParent"
      v-model="value"
      :has-error="!!errors.length"
      :id="fieldId"
      :is-disabled="hasDisabledParent"
      :is-readonly="hasReadonlyParent"
      is-required
      :max-length="maxLength"
    />
    <div v-else>{{ value ?? '-' }}</div>
  </FieldRowV2>
</template>
